import {
  IonApp,
  IonButtons,
  IonHeader,
  IonMenuButton,
  IonRouterOutlet,
  IonSplitPane,
  IonTitle,
  IonToolbar,
  setupIonicReact,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route } from "react-router-dom";
import Menu from "./components/Menu";
import Page from "./pages/Page";
// import StaffManagement from "./pages/settings/staffManagement";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* import '@ionic/react/css/palettes/dark.always.css'; */
/* import '@ionic/react/css/palettes/dark.class.css'; */
// import "@ionic/react/css/palettes/dark.system.css";

/* Theme variables */
import "./theme/variables.css";
import React from "react";
import { AuthContext, useAuthInit } from "./Auth";
import LoginPage from "./pages/LoginPage";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";

import GeneralSettings from "./pages/settings/GeneralSettings";
// import { Dashboard } from "@mui/icons-material";
import MainDashboard from "./pages/MainDashboard";
import SetUpBusiness from "./pages/settings/SetUpBusiness";
import BusinessDashboard from "./pages/settings/BusinessDashboard";

import StaffRegistration from "./pages/StaffRegistration";
import StaffManagement1 from "./pages/settings/StaffManagement1";
import GenerateInviteCode from "./pages/Business/GenerateInviteCode";
import AuditTrail from "./pages/audit/AuditTrail";
import StaffWelcomePage from "./pages/settings/StaffWelcomePage";
import { getBusinessData, getUser } from "./common/utils";
import { useBusinessContext } from "./context/business-context";
import MainDashboard_coop from "./pages/MainDashboard_coop";
import MainDashboard_xmas from "./pages/MainDashboard_xmas";
import MainDashboard_ajo from "./pages/MainDashboard_ajo";
import Profile from "./pages/members/Profile";
import PosPage_hotel_shop_online from "./pages/saas_sales_app/pos/PosPage_hotel_shop_online";
import CreateLedger from "./pages/ledgers/CreateLedger";
import RegisterMembers from "./pages/members/RegisterMembers";
import LoanApplication from "./pages/loans/LoanApplication";
import LoanApproval from "./pages/loans/LoanApproval";
import LoanRunning from "./pages/loans/LoanRunning";
import PaymentApproval from "./pages/loans/PaymentApproval";
import MembersList from "./pages/members/MembersList";
import ManageLedger from "./pages/ledgers/ManageLedger";
import LedgerPosting from "./pages/tellerFrontDesk/LedgerPosting";
import CashWithdrawal from "./pages/tellerFrontDesk/CashWithdrawal";
import WithdrawalRequest from "./pages/tellerFrontDesk/WithdrawalRequest";
import MemberWithdrawal from "./pages/members/MemberWithdrawal";
import MemberWithdrawalList from "./pages/members/MemberWithdrawalList";
import ApproveMembership from "./pages/members/ApproveMembership";
import SavingsReport from "./pages/savings/SavingsReport";
import PostingReport from "./pages/tellerFrontDesk/PostingReport";
import LedgerReport from "./pages/report/LedgerReport";
import FinancialReport from "./pages/report/FinancialReport";
import TrialBalanceReport from "./pages/report/TrialBalanceReport";
import LoanClearOff from "./pages/loans/LoanClearOff";
import IncomeExpensePosting from "./pages/tellerFrontDesk/IncomeExpensePosting";
import Messaging from "./pages/Messaging/Messaging";
import OverdueSavingsReport from "./pages/report/OverdueSavingsReport";
import InconsistentSavers from "./pages/savings/InconsistentSavers";
import InterestPayment from "./pages/report/InterestPayment";
import DividendPayment from "./pages/report/DividendPayment";
import ManageStaff from "./pages/staff/ManageStaff";
import Branches from "./pages/branches/Branches";
import CreateBranch from "./pages/branches/CreateBranch";
// import ManageCustomers from "./pages/customers/Customers";
import UploadUsersPage from "./pages/upload/UploadUsersPage";
import BulkPosting from "./pages/upload/BulkPosting";
import FinancialReportBranch from "./pages/report/FinancialReportBranch";
import CreateLedgerBranch from "./pages/ledgers/CreateLedgerBranch";
import ManageLedgerBranch from "./pages/ledgers/ManageLedgerBranch";
import ElectionVotingPage from "./pages/ElectionVotingPage";
import ReversedOrder from "./pages/saas_club_app/accounts/ReversedOrderx";
import SalesDashboard from "./pages/saas_club_app/accounts/SalesDashboardx";
import VendorPerformance from "./pages/saas_club_app/vendors/VendorPerformance";
import InventoryUsageReport from "./pages/saas_club_app/vendors/InventoryUsage";
import WalletReport from "./pages/saas_club_app/wallet/WalletReport";
import NotificationAlert from "./pages/saas_club_app/NotificationAlert";
import NewsAlert from "./pages/saas_club_app/Profile/NewsAlert";
import BarRequestPage from "./pages/saas_club_app/barman/bar-request";
import BarOrdersPage from "./pages/saas_club_app/barman/orders";
import BarSalesPage from "./pages/saas_club_app/barman/bar-sales";
import Inventory from "./pages/saas_club_app/warehouse/Inventory";
import PurchaseOrderRequestPage from "./pages/saas_club_app/warehouse/purchase-order";
import StockMovementList from "./components/warehouse/stockmovementlist";
import WarehouseTransferPage from "./pages/saas_club_app/warehouse/warehouse-transfer";
import Vendor from "./pages/saas_club_app/warehouse/Vendor";
import Movements from "./components/warehouse/movement";
import Transfers from "./components/warehouse/transfer";
import StewardOrdersPage from "./pages/saas_club_app/steward/orders";
import POSPage from "./pages/saas_club_app/barman/bar-orders";
import Items from "./pages/saas_club_app/barman/Items";
import { useEffect } from "react";
import { baseURL, requestID, config } from "./common/utils";
import NotificationListener from "./pages/saas_club_app/LocalNotification";
import { ToastContainer } from "react-toastify";
import Accreditation from "./pages/saas_club_app/Election/Accreditation";
import WinnersPage from "./pages/saas_club_app/Election/WinnersPage";
import VotingPage from "./pages/saas_club_app/Election/VotingPage";
import MonitorPage from "./pages/saas_club_app/Election/MonitorPage";
import ElectionSetup from "./pages/saas_club_app/Election/ElectionSetup";
import ManageElection from "./pages/saas_club_app/Election/ManageElection";
import ViewResultPage from "./pages/saas_club_app/Election/ViewResultPage";
import PurchaseOrderApproval from "./pages/saas_club_app/accounts/PurchaseOrderAproval";
import PurchaseOrderAudit from "./pages/saas_club_app/accounts/PurchaseOrderAudit";
import AddAspirant from "./pages/saas_club_app/Election/AddAspirants";
import AddPosition from "./pages/saas_club_app/Election/AddPositions";
import BarhandoverReport from "./pages/saas_club_app/barman/BarhandoverReport";
import PurchaseOrderRequestPage_PO from "./pages/saas_club_app/warehouse/purchase-order_po";
import PurchaseOrderVettingApproval from "./pages/saas_club_app/accounts/PurchaseOrderVettingApproval";
import PurchaseOrderPresidentApproval from "./pages/saas_club_app/accounts/PurchaseOrderPresidentApproval";
import RequsitionPage from "./pages/saas_club_app/bar-secretary/RequsitionPage";
import { CategoryOutlined, CreateSharp } from "@mui/icons-material";
import CreateStaff from "./pages/staff/CreateStaff";
import CreateMember from "./pages/staff/CreateMember";
import StewardDashboard from "./pages/saas_club_app/steward/StewardDashboard";
import StewardOrderReports from "./pages/saas_club_app/steward/StewardOrderReports";
import ProductSetup from "./pages/saas_club_app/warehouse/ProductSetup";
import Category from "./pages/saas_club_app/warehouse/Category";
import POSPage_Steward from "./pages/saas_club_app/steward/bar-orders_steward";
import StewardRequestPage from "./pages/saas_club_app/steward/steward-request";
import POSPage_StewardSelf from "./pages/saas_club_app/steward/bar-orders-self";
import StewardPurchaseOrderRequestPage from "./pages/saas_club_app/barman/purchase-order";
import SupportTicket from "./pages/settings/setup/SupportTicket";
import AdminFaqs from "./pages/settings/setup/AdminFaqs";
import OrderReports from "./pages/saas_club_app/steward/OrderReports";
import StewardItems from "./pages/saas_club_app/steward/StewardItems";
import steward_stocklist from "./pages/saas_club_app/barman/ViewStewardStock";
import ViewStewardStock from "./pages/saas_club_app/barman/ViewStewardStock";
import StewardStockTransferLogs from "./pages/saas_club_app/barman/StewardStockTransferLogs";
import MyStewardStockTransferLogs from "./pages/saas_club_app/steward/StewardStockTransferLogs";
import StewardStocklist from "./pages/saas_club_app/barman/stewardStocklist";
import MyAccountArea from "./pages/saas_club_app/steward/MyAccountArea";
import SalesPOSPage from "./pages/saas_sales_app/pos/PosPage";
import CustomerAccountPage from "./pages/saas_sales_app/pos/CustomerAccountPage";
import SalesReportPage from "./pages/saas_sales_app/report/SalesReportPage";
import FundCustomerWallet from "./pages/saas_sales_app/funding/FundCustomerWallet";
import FundCustomerReport from "./pages/saas_sales_app/funding/FundCustomerReport";
import ManagerSalesReportPage from "./pages/saas_sales_app/report/ManagerSalesReportPage";
import StockStatus from "./pages/saas_sales_app/report/StockStatus";
import SalesAnalysis from "./pages/saas_sales_app/report/SalesAnalysis";
import PurchaseReport from "./pages/saas_sales_app/report/PurchaseReport";

import CustomersReport from "./pages/saas_sales_app/report/CustomersReport";
import OutstandingAnalysis from "./pages/saas_sales_app/outstanding/OutstandingAnalysis";
import BranchRequisitionPage from "./pages/saas_sales_app/Requisition/branch-requisition";
import ProductSetupPage from "./pages/saas_sales_app/products/ProductSetupPage";
import BOMListPage from "./pages/saas_sales_app/Requisition/BOMListPage";
import ManageBOMTable from "./pages/saas_sales_app/Requisition/BOMSetupForm";
// import BOMDetailsPages from "./pages/saas_sales_app/Requisition/BOMDetails";
import BOMDetailPage from "./pages/saas_sales_app/Requisition/BOMSetupDetails";
import BranchRequestPage from "./pages/saas_sales_app/Requisition/BranchRequest";
import GradeSetupPage from "./pages/saas_sales_app/products/GradeSetuppage";
import CategoryPage from "./pages/saas_sales_app/products/CategoryPage";
import PayrollSystem from "./pages/saas_hr_app/payrolls/Payroll";
import EmployeeUploadPage from "./pages/saas_hr_app/payrolls/employee-upload";
import PayrollSettings from "./pages/saas_hr_app/payrolls/payroll-settings";
import ManagementPage from "./pages/saas_hr_app/WhistleBlowing/ManagementPage";
import CasePage from "./pages/saas_hr_app/WhistleBlowing/CasePage";
import RecommendationList from "./pages/saas_hr_app/SelfServices-M/RecommendationList";
import ManagerRequisitionsPage from "./pages/saas_hr_app/requisitions/ManagerRequisition";
import DisciplinaryPage from "./pages/saas_hr_app/DisciplinaryManagement/DisciplinaryPage";
import IssueDisciplinaryQueryPage from "./pages/saas_hr_app/DisciplinaryManagement/IssueDisciplinaryQueryPage";
import DisciplinaryCaseDetailPage from "./pages/saas_hr_app/DisciplinaryManagement/DisciplinaryCaseDetailPage";
import LeavePage from "./pages/saas_hr_app/LeaveManagement/LeavePage";
import ApplyLeavePage from "./pages/saas_hr_app/LeaveManagement/ApplyLeavePage";
import LeaveDetailPage from "./pages/saas_hr_app/LeaveManagement/LeaveDetailPage";
import JobPostPage from "./pages/saas_hr_app/jobs/JobPostPage";
import JobListPage from "./pages/saas_hr_app/jobs/JobListPage";
import JobDetails from "./pages/saas_hr_app/jobs/JobDetails";
import JobManagementPage from "./pages/saas_hr_app/jobs/JobManagementPage";
import JobApplicantPage from "./pages/saas_hr_app/jobs/JobApplicantPage";
import JobQuestionsPage from "./pages/saas_hr_app/jobs/JobQuestionPage";
import JobApplicationForm from "./pages/saas_hr_app/jobs/JobApplicationForm";
import EmployerLeaveView from "./components/leave/EmployerLeaveView";
import EmployeeDisciplinaryView from "./components/disciplinary/EmployeeDisciplinaryView";
import HROnboardingView from "./components/Onboarding2/HROnboardingView";
import OnboardingPage from "./pages/saas_hr_app/Onboarding2/OnBoardingPage2";
import EmployeeLeaveView from "./components/leave/EmployeeLeaveView";
import MyRequisitions from "./pages/saas_hr_app/requisitions/myRequisition";
import CreateRequisitionPage from "./pages/saas_hr_app/requisitions/createRequsitions";
import UserRecommendation from "./pages/saas_hr_app/SelfServices-M/UserRecommendation";
import RequisitionDetails from "./pages/saas_hr_app/requisitions/RequisitonDetails";
import SalesRecieptPage from "./pages/saas_sales_app/report/SalesRecieptPage";
import ManagerSalesReportPage_R from "./pages/saas_sales_app/report/ManagerSalesReportPage_R";
import ATSProjects from "./pages/saas_hr_consulting/ats/projects";
import ATSProjects_staff from "./pages/saas_hr_consulting/ats/projects_staff";

import ATSProjectDetail from "./pages/saas_hr_consulting/ats/project-details";
import ATSJobApplicants from "./pages/saas_hr_consulting/ats/job-applicants";
import ProjectDetail from "./pages/saas_hr_consulting/project/ProjectDetail";
import ProjectSetup from "./pages/saas_hr_consulting/project/ProjectSetup";
import CreateCourse from "./pages/saas_hr_consulting/lms/CreateCourse";
import ProjectApplicants from "./pages/saas_hr_consulting/notification-alert/ProjectApplicants";
import AllProjects from "./pages/saas_hr_consulting/notification-alert/projects";
import HRDashboard from "./pages/saas_hr_consulting/Business-Owner/BusinessOwnerDashboard/HrDashboard";
import JobSetup from "./pages/saas_hr_consulting/Business-Owner/BusinessOwnerDashboard/JobSetup";
import BusinessOwnerDashboard from "./pages/saas_hr_consulting/BusinessOwnerDashboard/BusinessOwnerDashboard";
import BusinessOwnerProjectDetail from "./pages/saas_hr_consulting/BusinessOwnerDashboard/BusinessOwnerProjectDetails";
import ApplicantManagement from "./pages/saas_sales_app/ReportAnalytics/ApplicantsList";
import ProjectChart from "./pages/saas_sales_app/ReportAnalytics/ProjectChart";
import PurchaseOrderRequestPageSales from "./pages/saas_club_app/warehouse/purchase-order_sales";
import PurchaseOrderAuditSales from "./pages/saas_sales_app/accountant/PurchaseOrderAuditSales";
import PurchaseOrderPresidentApprovalSales from "./pages/saas_club_app/accounts/PurchaseOrderPresidentApprovalSales";
import { AdminServiceRequests } from "./pages/saas_hr_consulting/gkgs hr 3/admin-service-request";
import StaffManagementPage from "./pages/saas_hr_consulting/gkgs hr 3/staffs";
import MailPage from "./pages/saas_hr_consulting/notification-alert/ChatPage";
import { StaffRequestPage } from "./pages/saas_hr_consulting/gkgs hr 3/staff-service-request";
import { BusinessRequestPage } from "./pages/saas_hr_consulting/gkgs hr 3/business-request";
import JobSetUpProjectDetail from "./pages/saas_hr_consulting/BusinessOwnerDashboard/JobSetupDetails";
import Transfers_PC from "./components/warehouse/transfer_pc";
import EmployerDisciplinaryView from "./components/disciplinary/EmployerDisciplinaryView";
import Create from "./components/lms_saas/Create";
import ViewEnrolledCourse from "./components/lms_saas/ViewEnrolledCourse";
import EnrollCourse from "./components/lms_saas/EnrollCourse";
import InAppMesssging from "./components/inappmessage/InAppMesssging";
import HrConsultingPage from "./pages/settings/HrConsultingPage";
import HraasPage from "./pages/settings/HraasPage";
import CooperativePage from "./pages/settings/CooperativePage";
import Recommendation from "./pages/saas_hr_app/SelfServices-M/Recommendation";
import WhistlePage from "./pages/saas_hr_app/WhistleBlowing/WhistlePage";
import StaffPage from "./pages/saas_hr_app/WhistleBlowing/StaffPage ";
import MarkAttendance from "./components/MarkAttendance";
import MarkPerformance from "./components/MarkPerformance";
import CustomerAccountPage_account from "./pages/saas_sales_app/pos/CustomerAccountPage_accounts";
import Bookprintcalc from "./pages/Bookprintcalc";
import PosPage_Gift_card from "./pages/saas_sales_app/pos/PosPage_Gift_card";
import PosPage_Crypto from "./pages/saas_sales_app/pos/PosPage_Crypto";
import CompanyCareerPage from "./pages/saas_hr_app/jobs/CompanyJobsPage";
import MyPayslips from "./pages/saas_hr_app/payrolls/MyPayslips";
import CustomerAccountPage_giftcard_crypto from "./pages/saas_sales_app/pos/CustomerAccountPage_giftcard_crypto";
import StockSalesReportPage from "./pages/saas_sales_app/pos/StockSalesReportPage";
// import ManagerSalesReportPage_R_Crypto from "./pages/saas_sales_app/report/ManagerSalesReportPage_R_Crypto";
// import ManagerSalesReportPage_R_Giftcard from "./pages/saas_sales_app/report/ManagerSalesReportPage_R_Giftcard";
import ManagerSalesReportPage_R_Giftcard_audit from "./pages/saas_sales_app/report/ManagerSalesReportPage_R_Giftcard_audit";
import ForgotPassword from "./pages/forgot_password";
import CustomerListPage from "./pages/saas_sales_app/report/CustomerListPage";
import CustomerAccountPage_accounts_exchange from "./pages/saas_sales_app/pos/CustomerAccountPage_accounts_exchange";
import StaffPerformancePage1 from "./pages/saas_sales_app/report/StaffPerformancePage1";
import CustomerPerformancePage1 from "./pages/saas_sales_app/report/CustomerPerformancePage1";
import ProductPerformancePage1 from "./pages/saas_sales_app/report/ProductPerformancePage1";
import CustomerStatusReportPage from "./pages/saas_sales_app/pos/CustomerStatusReportPage";
import ManagerSalesReportPage_R_Giftcard from "./pages/saas_sales_app/report/ManagerSalesReportPage_R_Giftcard";
import ProcessorPerformancePage1 from "./pages/saas_sales_app/report/ProcessorPerformancePage1";
import CustomerAccountPage_giftcard_crypto_all from "./pages/saas_sales_app/pos/CustomerAccountPage_giftcard_crypto_all";
import SundryDebtorsPage from "./pages/saas_sales_app/report/SundryDebtorsPage";
import SundryCreditorsPage from "./pages/saas_sales_app/report/SundryCreditorsPage";
import CustomerProfitReportPage from "./pages/saas_sales_app/pos/CustomerProfitReportPage";
import CustomerAccountPage_conf_giftcard_crypto_all from "./pages/saas_sales_app/pos/CustomerAccountPage_conf_giftcard_crypto_all";
import AdminTerms from "./pages/settings/setup/AdminTerms";
import SetupExternalProcessorsPage from "./pages/saas_sales_app/report/SetupExternalProcessorsPage";
import StaffManagementCRM from "./pages/saas_hr_consulting/gkgs hr 3/staffs_crm";
import ManagerSalesReportPage_R_Exchange from "./pages/saas_sales_app/report/ManagerSalesReportPage_R_Exchange";
import StaffManagementHRConsultant from "./pages/saas_hr_consulting/gkgs hr 3/staffs_hrconsulting";
import StaffManagementGeneral from "./pages/saas_hr_consulting/gkgs hr 3/staffs_hrconsulting";
import ProductSetupPage_all_branch from "./pages/saas_sales_app/products/ProductSetupPage_all_branch";
import CustomerAccountPage_giftcard_crypto_pending from "./pages/saas_sales_app/pos/CustomerAccountPage_giftcard_crypto_pending";
import CustomerAccountPage_giftcard_crypto_pending_om from "./pages/saas_sales_app/pos/CustomerAccountPage_giftcard_crypto_pending_om";
import CustomerAccountPage_crypto from "./pages/saas_sales_app/pos/CustomerAccountPage_crypto";
import Inventory_business from "./pages/saas_club_app/warehouse/Inventory_business";
import ManagerSalesReportPage_R_Exchange_usd from "./pages/saas_sales_app/report/ManagerSalesReportPage_R_Exchange_usd";
import SetupCryptoType from "./pages/saas_sales_app/report/SetupCryptoType";
import CustomerAccountPage_conf_crypto from "./pages/saas_sales_app/pos/CustomerAccountPage_conf_crypto";
import ModulePage from "./pages/saas_hr_consulting/project/ModulePage";
import StaffManagementCRM_all from "./pages/saas_hr_consulting/gkgs hr 3/staffs_crm_all";
import ManagerSalesReportPage_R_Exchange_giftcard_history from "./pages/saas_sales_app/report/ManagerSalesReportPage_R_Exchange_giftcard_history";
import SetupGiftcardType from "./pages/saas_sales_app/report/SetupGiftcardType";
import SalesRecieptPage_Ex from "./pages/saas_sales_app/report/SalesRecieptPage_Ex";
import CustomerAccountPage_search_by_code from "./pages/saas_sales_app/pos/CustomerAccountPage_search_by_code";
import PaymentHistory from "./pages/sabishare/vendors/PaymentHistory_v";
import CommissionDeductions from "./pages/sabishare/vendors/CommissionDeductions_v";
import UserManagement from "./pages/sabishare/vendors/UserManagement_v";
import AnalyticsDashboard from "./pages/sabishare/vendors/AnalyticsDashboard_v";
import ContentCommunication from "./pages/sabishare/vendors/ContentCommunication";
import AdminTaskManagement from "./pages/saas_hr_app/StaffActivity/AdminTaskManagement";
import ActivityReporting from "./pages/saas_hr_app/StaffActivity/ActivityReporting";
import PosPage_hotel_booking from "./pages/saas_sales_app/pos/PosPage_hotel_booking";
import PosPage_bar from "./pages/saas_sales_app/pos/PosPage_bar";
import BeneficiaryReport from "./pages/sabishare/vendors/BeneficiaryReport";
import CustomerAccountPage_reservations from "./pages/saas_sales_app/pos/CustomerAccountPage_reservations";
import CustomerAccountPage_search_by_code_1 from "./pages/saas_sales_app/pos/CustomerAccountPage_search_by_code_1";
import StewardRequestPage_branch from "./pages/saas_club_app/steward/steward-request_branch";
import CustomerAccountPage_checkin_checkout from "./pages/saas_sales_app/pos/CustomerAccountPage_checkin_checkout";
import LedgerPosting_sales_only from "./pages/tellerFrontDesk/LedgerPosting_sales_only";
import LedgerReport_sales_only from "./pages/report/LedgerReport_sales_only";
import LedgerReport_sales_only_xchange from "./pages/report/LedgerReport_sales_only_xchange";
import PosPage_hotel_shop from "./pages/saas_sales_app/pos/PosPage_hotel_shop";
import CustomerAccountPage_giftcard_crypto_fdesk from "./pages/saas_sales_app/pos/CustomerAccountPage_giftcard_crypto_fdesk";
import HotelBookingPage_passed from "./pages/saas_sales_app/pos/PosPage_hotel_booking-allow_passed_date";
import ManageCustomers from "./pages/branches/Customers";
import GRNManager from "./pages/saas_accounting_app/inventory/GRNManager";
import InventoryManagement from "./pages/saas_accounting_app/inventory/InventoryManagement";
import WriteOffManager from "./pages/saas_accounting_app/inventory/WriteOffManager";
import VendorList from "./pages/saas_accounting_app/vendors/VendorList";
import VendorDetail from "./pages/saas_accounting_app/vendors/VendorDetail";
import { ProcedureList } from "./pages/saas_accounting_app/procedures";
import { TaxList } from "./pages/saas_accounting_app/taxes";
import WarehouseRequisitionSystem from "./pages/saas_accounting_app/purchase-requsition";
import WarehouseRequisitionPage from "./pages/saas_accounting_app/view-purchase-requsition";
import ItemRequestPage from "./pages/saas_accounting_app/items-request";
import ItemTransferPage from "./pages/saas_accounting_app/items-transfer";
import PurchaseOfficerPage from "./pages/saas_accounting_app/purchase-officer";
import { coreAccountingPages } from "./pages/saas_accounting_app/accountant";
import { customerRoutes } from "./routes";
import AssetRegisterList from "./pages/saas_accounting_app/accountant/AssetRegister/AssetRegisterList";
import { ToastProvider } from "./context/ToastContext";
import PackagePosting from "./pages/saas_accounting_app/accountant/GeneralLedger/PackagePosting";
import GeneralLedgerView from "./pages/saas_accounting_app/accountant/GeneralLedger/GeneralLedgerView";
import { CustomerForm, InvoiceDetail, CustomerDetail, } from ".";
import CustomerInvoices from "./pages/saas_accounting_app/customer-ar/CustomerInvoices";
import CustomerStatement from "./pages/saas_accounting_app/customer-ar/CustomerStatement";
import CustomerList from "./pages/saas_accounting_app/customer-ar/CustomerList";
import ManualLedgerPosting from "./pages/saas_accounting_app/accountant/GeneralLedger/ManualLedgerPosting";
import ReversalEntries from "./pages/saas_accounting_app/accountant/GeneralLedger/ReversalEntries";
import PostingsByPostCode from "./pages/saas_accounting_app/accountant/GeneralLedger/PostingsByPostCode";
import MyReport from "./pages/saas_accounting_app/accountant/GeneralLedger/MyReport";
import AllReport from "./pages/saas_accounting_app/accountant/GeneralLedger/AllReport";
import CustomerAging from "./pages/saas_accounting_app/customer-ar/CustomerAging";
import CustomerReceipts from "./pages/saas_accounting_app/customer-ar/CustomerReceipts";
import PurchaseOrderDashboard from "./pages/saas_accounting_app/vendors/PurchaseOrderDashboard";
import InvoiceDashboard from "./pages/saas_accounting_app/vendors/sub/InvoiceDashboard";
import DeliveryNoticeDashboard from "./pages/saas_accounting_app/vendors/DeliveryNoticeDashboard";
import DiscrepancyDashboard from "./pages/saas_accounting_app/vendors/DiscrepancyDashboard";
import PaymentHistoryDashboard from "./pages/saas_accounting_app/vendors/sub/PaymentHistoryDashboard";
import DeviceCheckPage from "./components/DeviceCheckPage";
import DeviceManagement from "./pages/ManageDeviceLocking";
import LedgerReport_sales_only_admin_view from "./pages/report/LedgerReport_sales_only_admin_view";
import CustomerAccountPage_pending from "./pages/saas_sales_app/pos/CustomerAccountPage_pending";
import RefundRequestForm from "./pages/saas_accounting_app/customer-ar/RefundRequestForm";
import InvoiceForm from "./pages/saas_accounting_app/customer-ar/InvoiceForm";
import RegisterPage from "./pages/saas_accounting_app/vendors/RegisterPage";
import CMDApprovalPage from "./pages/saas_accounting_app/cmd-approval";
import AuditOfficerPage from "./pages/saas_accounting_app/audit-officer";
import CbtCourses from "./pages/saas_cbt/CBTCourses";
import CbtExams from "./pages/saas_cbt/CBTExams";
import CBTQuestionsDashboard from "./pages/saas_cbt/CBTQuestionsDashboard";
import StudentExamInterface from "./pages/saas_cbt/CBTStudents";
import CBTExamReport from "./pages/saas_cbt/CBTExamReport";
import StudentManagementDashboard from "./pages/saas_cbt/CBTMangeStudent";

import ManagerSalesReportPage_R_admin_view from "./pages/saas_sales_app/report/ManagerSalesReportPage_R_admin_view";
import CustomerAccountPage_pending_admin_view from "./pages/saas_sales_app/pos/CustomerAccountPage_pending_admin_view";
import CreateLedgerBranch_update from "./pages/ledgers/CreateLedgerBranch_update";
import InvoiceSuspense from "./pages/ledgers/InvoiceSuspense";
import SuspenseInvoiceDashboard from "./pages/saas_accounting_app/accountant/SuspenseInvoiceDashboard";
import ChartOfAccountsPage from "./pages/saas_accounting_app/accountant/GeneralLedger/ChartOfAccountsPage";
import ChartOfAccountsList from "./pages/saas_accounting_app/accountant/GeneralLedger/ChartOfAccountsList";
import FinancialReportTree from "./pages/saas_accounting_app/accountant/GeneralLedger/FinancialReportTree";
import ChartOfAccountsList_b from "./pages/saas_accounting_app/accountant/GeneralLedger/ChartOfAccountsList_b";
import SimpleLedgerReport from "./pages/saas_accounting_app/accountant/GeneralLedger/ChartOfAccountsList_b";
import BalanceSheet from "./pages/saas_accounting_app/accountant/GeneralLedger/BalanceSheet";
import ProfitAndLoss from "./pages/saas_accounting_app/accountant/GeneralLedger/ProfitAndLoss";
import BalanceSheetReport from "./pages/saas_accounting_app/accountant/GeneralLedger/BalanceSheet";
import AvailableRoomsToday from "./pages/saas_sales_app/pos/PosPage_hotel_availability";
import { Layout } from "lucide-react";
import ReceptionistSalesReport from "./pages/saas_sales_app/report/Receptionist_report";
import ReorderLevels from "./pages/saas_accounting_app/inventory/ReorderLevels";
import StocksAlert from "./pages/saas_accounting_app/inventory/StocksAlert";
import InventoryReportingValuation from "./pages/saas_accounting_app/inventory/InventoryReportingValuation";
import Housekeeping from "./pages/saas_sales_app/hotel/Housekeeping";
import AssignmentReport from "./pages/saas_sales_app/hotel/AssignmentReport";
import Housekeeping_bulk from "./pages/saas_sales_app/hotel/Housekeeping_bulk";
import RoomStatusReport from "./pages/saas_sales_app/hotel/RoomStatusReport";
import RegisterLostAndFound from "./pages/saas_sales_app/hotel/RegisterLostAndFound";
import WaiterAttendance from "./pages/saas_sales_app/hotel/WaiterAttendance";
import WaiterAssignment from "./pages/saas_sales_app/hotel/WaiterAssignment";
import AssignmentHistory from "./pages/saas_sales_app/hotel/AssignmentHistory";
import AttendanceHistory from "./pages/saas_sales_app/hotel/AttendanceHistory";
import AddInventory from "./pages/saas_sales_app/hotel/AddInventory";
import RemoveInventory from "./pages/saas_sales_app/hotel/RemoveInventory";
import InventoryHistory from "./pages/saas_sales_app/hotel/InventoryHistory";
import RecordSale from "./pages/saas_sales_app/hotel/RecordSale";
import SalesDashboardBFSupervisor from "./pages/saas_sales_app/hotel/SalesDashboardBFSupervisor";
import CreateRequisitionFb from "./pages/saas_sales_app/hotel/CreateRequisitionFb";
import RequisitionHistoryFb from "./pages/saas_sales_app/hotel/RequisitionHistoryFb";
import DispenseStockFb from "./pages/saas_sales_app/hotel/DispenseStockFb";
import DispenseHistoryFb from "./pages/saas_sales_app/hotel/DispenseHistoryFb";
import VendorReport from "./pages/sabishare/vendors/VendorReport";
import DonorReport from "./pages/sabishare/vendors/DonorReport";
import FeedbackPage from "./pages/saas_sales_app/pos/feedback";
import ManageOnlineBooking from "./pages/saas_sales_app/pos/ManageOnlineBooking";
import OnlineCategoryPage from "./pages/saas_sales_app/products/OnlineCategoryPage";
import CommissionManager from "./pages/sabishare/vendors/CommissionManager";
import RevenueReport from "./pages/sabishare/vendors/RevenueReport";


// import PayrollSystem from "./pages/saas_hr_app/hr/payrolls/Payroll";
// import BOMDetailsPage from "./pages/saas_sales_app/Requisition/BOMDetails";
setupIonicReact();

const App: React.FC = () => {



  const authInitState = useAuthInit();
  const {
    selectedBusinessId,
    setSelectedBusinessId,
    selectedBusinessTypeId,
    setSelectedBusinessTypeId,
    selectedBusinessName,
    setSelectedBusinessName,
    selectedBusinessTypeName,
    setSelectedBusinessTypeName,
    selectedRoleID,
    setSelectedRoleID,
  } = useBusinessContext();

  const userId = getUser()?.loginData?.userID;
  const businessTypeId = getBusinessData()?.business_type_id;

  const pageMap = {
    "1001": <CooperativePage />,
    "1007": <StaffWelcomePage />,
    "1008": <HraasPage />,
    "1009": <StaffWelcomePage />,
    "1010": <HrConsultingPage />,
  };

  // console.log(businessTypeId);
  return (
    <IonApp>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthContext.Provider value={{ isLoggedIn: authInitState.isLoggedIn }}>

          <IonReactRouter>
            {authInitState.loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <p>Loading...</p>
              </div>
            ) : authInitState.isLoggedIn ? (
              <IonSplitPane contentId="main">
                <Menu />

                <IonRouterOutlet id="main"
                  className="pageDown ion-padding"
                >
                  <>


                    <Route path={"/folder/online_payment_feedback"}>
                      <FeedbackPage />
                    </Route>

                    {/* ✅ PUBLIC CALLBACK ROUTE */}

                    <NotificationListener userId={userId} />

                    <Route exact path="/">
                      <Redirect to="/login" />
                    </Route>

                    <Route path={"/login"}>
                      {(Number(getUser().loginData?.roleID) === 2 ||
                        Number(getUser().loginData?.roleID) === 3 ||
                        Number(getUser().loginData?.roleID) === 4 ||
                        Number(getUser().loginData?.roleID) === 11 ||
                        Number(getUser().loginData?.roleID) === 13 ||
                        Number(getUser().loginData?.roleID) === 15 ||
                        Number(getUser().loginData?.roleID) === 5) && (
                          <StaffWelcomePage />
                          //  <MainDashboard />
                        )}



                      {pageMap[String(businessTypeId)] || null}

                      {/* <StaffWelcomePage /> */}

                      {Number(getUser().loginData?.roleID) === 9 && (
                        // <MainDashboard />
                        <BusinessDashboard />
                      )}
                    </Route>

                    <Route path={"/folder/mainDashboard_coop"}>
                      <MainDashboard_coop />
                    </Route>
                    <Route path={"/folder/mainDashboard_xmas"}>
                      <MainDashboard_xmas />
                    </Route>

                    <Route path={"/folder/mainDashboard_ajo"}>
                      <MainDashboard_ajo />
                    </Route>
                    <Route path={"/folder/setUpBusiness"}>
                      <SetUpBusiness />
                    </Route>
                    <Route path={"/folder/payment_history_sabi"}>
                      <PaymentHistory />
                    </Route>
                    <Route path={"/folder/view_commissions_sabi"}>
                      <CommissionManager />
                    </Route>
                    <Route path={"/folder/manage_users_sabi"}>
                      <UserManagement />
                    </Route>
                    <Route path={"/folder/view_analytics_sabi"}>
                      <AnalyticsDashboard />
                    </Route>
                    <Route path={"/folder/manage_content_comm_sabi"}>
                      <ContentCommunication />
                    </Route>
                    <Route path={"/folder/view_beneficiary_reports_sabi"}>
                      <BeneficiaryReport />
                    </Route>
                    <Route path={"/folder/view_vendors_reports_sabi"}>
                      <VendorReport />
                    </Route>
                    <Route path={"/folder/view_donor_reports_sabi"}>
                      <DonorReport />
                    </Route>

                    <Route path={"/folder/view_revenue_dashboard_sabi"}>
                      <RevenueReport />
                    </Route>




                    <Route path={"/folder/device-check"}>

                      <DeviceCheckPage />
                    </Route>

                    <Route path={"/folder/manage_device_locking"}>

                      <DeviceManagement />
                    </Route>


                    <Route path={"/folder/BusinessPage"}>
                      <BusinessDashboard />
                    </Route>
                    <Route path={"/folder/myaccountarea"}>
                      <MyAccountArea />
                    </Route>

                    <Route path={"/folder/vote"}>
                      <ElectionVotingPage />
                    </Route>

                    <Route exact path="/folder/staffManagement/:idx">
                      <StaffManagement1 />
                    </Route>
                    <Route path={`/folder/profile`}>
                      <Profile />
                    </Route>

                    <Route path={`/folder/generalSettings/:name`}>
                      <GeneralSettings />
                    </Route>

                    <Route path={"/folder/invite-code/:id"}>
                      <GenerateInviteCode />
                    </Route>
                    <Route path={"/folder/audit-trail/:id"}>
                      <AuditTrail />
                    </Route>
                    <Route path={"/folder/audit-trail/"}>
                      <AuditTrail />
                    </Route>

                    <Route path={"/folder/staffWelcomePage"}>
                      <StaffWelcomePage />
                    </Route>

                    <Route path={"/folder/manage-staffs/:id"}>
                      <ManageStaff />
                    </Route>

                    <Route path={`/folder/createLedgerBranch/:name`}>
                      {" "}
                      <CreateLedgerBranch />
                    </Route>

                    <Route path={`/folder/createLedger/:name`}>
                      {" "}
                      <CreateLedgerBranch_update />
                    </Route>

                    <Route path={`/folder/customer-sales-invoices/`}>
                      <InvoiceSuspense invoiceId={""} />
                    </Route>

                    {/* <Route path={`/folder/createLedger/:name`}>
                    {" "}
                    <CreateLedger />
                  </Route> */}
                    <Route path={`/folder/memberRegistration/:name`}>
                      <RegisterMembers />
                    </Route>
                    <Route path={`/folder/loanApplication/:name`}>
                      <LoanApplication />
                    </Route>
                    <Route path={`/folder/loanApproval/:name`}>
                      <LoanApproval />
                    </Route>


                    <Route path={`/folder/loanRunning/loanRunning`}>
                      <LoanRunning />
                    </Route>
                    <Route path={`/folder/paymentApproval/:name`}>
                      <PaymentApproval />
                    </Route>
                    <Route path={`/folder/memebersList/:name`}>
                      <MembersList />
                    </Route>
                    <Route path={`/folder/manageLedgerBranch/:name`}>
                      <ManageLedgerBranch />
                    </Route>
                    <Route path={`/folder/manageLedger/:name`}>
                      <ManageLedger />
                    </Route>
                    {/* <Route path={`/folder/memberRegistration/:name`}>
                    <RegisterMembers />
                  </Route> */}
                    <Route path={`/folder/memberList/:name`}>
                      <MembersList />
                    </Route>

                    <Route path={`/folder/setupterms/:name`}>
                      <AdminTerms />
                    </Route>
                    <Route path={`/folder/manageLedger/:name`}>
                      <ManageLedger />
                    </Route>

                    <Route path={`/folder/ledgerPosting/:name`}>
                      <LedgerPosting />
                    </Route>
                    <Route path={`/folder/ledgerPosting_sales_only/:name`}>
                      <LedgerPosting_sales_only />
                    </Route>

                    <Route path={`/folder/xe1_xledger_Posting_sales_only/:name`}>
                      <LedgerPosting_sales_only />
                    </Route>

                    <Route path={`/folder/CashWithdrawal/:name`}>
                      <CashWithdrawal />
                    </Route>
                    <Route path={`/folder/WithdrawalRequest/:name`}>
                      <WithdrawalRequest />
                    </Route>

                    <Route path={`/folder/memberWitthdrawal/:name`}>
                      <MemberWithdrawal />
                    </Route>

                    <Route
                      path={`/folder/memberWithdrawalList/memberWithdrawalList/:name`}
                    >
                      <MemberWithdrawalList />
                    </Route>

                    <Route
                      path={`/folder/approveMembership/approveMembership/:name`}
                    >
                      <ApproveMembership />
                    </Route>

                    <Route path={`/folder/savingsReport/:name`}>
                      <SavingsReport />
                    </Route>

                    <Route path={`/folder/myPostingReport/:name`}>
                      <PostingReport />
                    </Route>
                    <Route path={`/folder/ledgerReport/:name`}>
                      <LedgerReport />
                    </Route>

                    <Route path={`/folder/ledgerReport_sales_only/:name`}>
                      <LedgerReport_sales_only_xchange />
                    </Route>

                    <Route path={`/folder/xe_xledger_Report_sales_only/:name`}>
                      <LedgerReport_sales_only />
                    </Route>


                    <Route path={`/folder/admin_xvn_ledger_Report_sales_only_view/:name`}>
                      <LedgerReport_sales_only_admin_view />
                    </Route>



                    <Route path={`/folder/financialReport/:name`}>
                      <FinancialReport />
                    </Route>

                    <Route path={`/folder/financialReportBranch/:name`}>
                      <FinancialReportBranch />
                    </Route>
                    <Route path={`/folder/trialBalance/:name`}>
                      <TrialBalanceReport />
                    </Route>
                    <Route path={`/folder/business-settings/`}>
                      <GeneralSettings />
                    </Route>

                    <Route path={`/folder/incomeexpensePosting/:name`}>
                      <IncomeExpensePosting />
                    </Route>
                    <Route path={`/folder/messaging/:name`}>
                      <Messaging />
                    </Route>

                    <Route path={`/folder/loanClearoff/:name`}>
                      <LoanClearOff />
                    </Route>

                    <Route path={`/folder/profile`}>
                      <Profile />
                    </Route>
                    <Route path={`/folder/hotel_booking/:name`}>
                      <PosPage_hotel_booking />
                    </Route>

                    <Route path={`/folder/2xc_hotel_online_booking_xc/:name`}>
                      <PosPage_hotel_shop_online />
                    </Route>

                    {/* <Route path={`/folder/online_payment_feedback`}>
                    <PosPage_hotel_shop_online />
                  </Route> */}




                    <Route path={`/folder/hotel_availablity/:name`}>
                      <AvailableRoomsToday />
                    </Route>

                    <Route path={`/folder/xhotel_hotel_booking_passed/:name`}>
                      <HotelBookingPage_passed />
                    </Route>

                    <Route path={`/folder/overdue_savings/:name`}>
                      <OverdueSavingsReport />
                    </Route>
                    <Route path={`/folder/inconsistentSavers/:name`}>
                      <InconsistentSavers />
                    </Route>
                    <Route path={`/folder/interestpayments/:name`}>
                      <InterestPayment />
                    </Route>
                    <Route path={`/folder/dividendpayments/:name`}>
                      <DividendPayment />
                    </Route>

                    <Route path={"/folder/setUpBusiness"}>
                      <SetUpBusiness />
                    </Route>

                    <Route path={"/folder/BusinessPage"}>
                      <BusinessDashboard />
                    </Route>

                    <Route exact path="/folder/staffManagement/:idx">
                      <StaffManagement1 />
                    </Route>
                    <Route path={"/folder/staffWelcomePage"}>
                      <StaffWelcomePage />
                    </Route>

                    <Route path={"/folder/branches/:idx"}>
                      <Branches />
                    </Route>
                    <Route path={"/folder/createbranches/:idx"}>
                      <CreateBranch />
                    </Route>

                    <Route path={"/folder/addAspirant"}>
                      <AddAspirant />
                    </Route>
                    <Route path={"/folder/addPosition"}>
                      <AddPosition />
                    </Route>

                    <Route path={"/folder/customers/:idx"}>
                      <ManageCustomers />
                    </Route>

                    <Route path={"/folder/uploadusers/:idx"}>
                      <UploadUsersPage />
                    </Route>

                    <Route path={"/folder/bulkuploadpostings/:idx"}>
                      <BulkPosting />
                    </Route>

                    <Route path={`/folder/reverseTransaction/:name`}>
                      <ReversedOrder />
                    </Route>
                    <Route path={`/folder/salesReport/:name`}>
                      <SalesDashboard />
                    </Route>
                    <Route path={`/folder/viewPerformance/:name`}>
                      <VendorPerformance />
                    </Route>
                    <Route path={`/folder/inventoryreport/:name`}>
                      <InventoryUsageReport />
                    </Route>
                    <Route path={`/folder/walletReport/:name`}>
                      <WalletReport />
                    </Route>

                    <Route path={`/folder/ledgerReport/:name`}>
                      <LedgerReport />
                    </Route>
                    <Route path={`/folder/inappMessages`}>
                      <NewsAlert />
                    </Route>

                    {/* barman */}
                    <Route path={`/folder/makearequest/:name`}>
                      <BarRequestPage />
                    </Route>
                    <Route path={`/folder/viewallorders/:name`}>
                      <BarOrdersPage />
                    </Route>
                    <Route path={`/folder/raise-order_gift_card/:name`}>
                      <PosPage_Gift_card />
                    </Route>

                    <Route path={`/folder/raise-order_crypto/:name`}>
                      <PosPage_Crypto />
                    </Route>
                    {/* <Route path={`/folder/raise-order_crypto/:name`}>
  <Layout title="Raise Crypto Order">
    <PosPage_Crypto />
  </Layout>
</Route> */}

                    <Route path={`/folder/setup_external_processor/:name`}>
                      <SetupExternalProcessorsPage />
                    </Route>

                    <Route path={`/folder/setup_crypto_type/:name`}>
                      <SetupCryptoType />
                    </Route>

                    <Route path={`/folder/setup_giftcard_type/:name`}>
                      <SetupGiftcardType />
                    </Route>

                    <Route path={`/folder/barsalesReport/:name`}>
                      <BarSalesPage />
                    </Route>

                    <Route path={`/folder/ApprovePurchaseOrder/:name`}>
                      <PurchaseOrderApproval />
                    </Route>

                    <Route path={`/folder/ApprovePurchaseAudit/:name`}>
                      <PurchaseOrderAudit />
                    </Route>

                    <Route path={`/folder/ApprovePurchaseAuditSales/:name`}>
                      <PurchaseOrderAuditSales />
                    </Route>

                    <Route path={`/folder/view-requisition/:name`}>
                      <RequsitionPage />
                    </Route>

                    <Route path={`/folder/barhandoverReport/:name`}>
                      <BarhandoverReport />
                    </Route>

                    <Route path={`/folder/barstockReport/:name`}>
                      <Items />
                    </Route>

                    <Route path={`/folder/stewardstockReport/:name`}>
                      <StewardItems />
                    </Route>
                    {/* warehouse */}
                    <Route path={`/folder/TrackInventory/:name`}>
                      <Inventory />
                    </Route>

                    <Route path={`/folder/TrackInventory_business/:name`}>
                      <Inventory_business />
                    </Route>

                    <Route path={`/folder/viewreorder/:name`}>
                      <NotificationAlert />
                    </Route>
                    <Route path={`/folder/reStockAlert/:name`}>
                      <Inventory />
                    </Route>
                    <Route path={"/folder/SupplierRequestManagementSales/:name"}>
                      <PurchaseOrderRequestPageSales />
                    </Route>
                    <Route path={"/folder/SupplierRequestManagement/:name"}>
                      <PurchaseOrderRequestPage />
                    </Route>
                    <Route path={"/folder/PurchaseOrderVettingApproval/:name"}>
                      <PurchaseOrderVettingApproval />
                    </Route>

                    <Route path={"/folder/SupplierRequestManagement_po/:name"}>
                      <PurchaseOrderRequestPage_PO />
                    </Route>
                    <Route path={"/folder/PurchaseOrderPresidentApproval/:name"}>
                      <PurchaseOrderPresidentApproval />
                    </Route>

                    <Route
                      path={"/folder/PurchaseOrderPresidentApprovalSales/:name"}
                    >
                      <PurchaseOrderPresidentApprovalSales />
                    </Route>

                    <Route path={"/folder/MainBarRequestsManagement/:name"}>
                      <WarehouseTransferPage />
                    </Route>

                    <Route path={"/folder/productsetup/:name"}>
                      <ProductSetupPage />
                    </Route>
                    <Route path={"/folder/categorysetup/:name"}>
                      <Category />
                    </Route>
                    <Route path={"/folder/ManageVendors/:name"}>
                      <Vendor />
                    </Route>
                    <Route path={"/folder/ViewStockTransfers/:name"}>
                      <Transfers />
                    </Route>

                    <Route
                      path={"/folder/ViewStockTransfers_production_centre/:name"}
                    >
                      <Transfers_PC />
                    </Route>

                    <Route path={"/folder/TransferStock/:name"}>
                      <Transfers />
                    </Route>
                    <Route path={"/folder/StockAuditLogs/:name"}>
                      <Movements />
                    </Route>

                    {/* steward */}
                    <Route path={"/folder/steward/orders/:name"}>
                      <StewardOrdersPage />
                    </Route>
                    <Route path={"/folder/viewallordersSteward/:name"}>
                      <StewardOrdersPage />
                    </Route>
                    <Route path={"/folder/makeanorder/:name"}>
                      <POSPage />
                    </Route>
                    <Route path={"/folder/makeanorder_steward/:name"}>
                      <POSPage_Steward />
                    </Route>
                    <Route path={"/folder/CastYourVote"}>
                      <VotingPage />
                    </Route>
                    <Route path={"/folder/PerformAccreditation"}>
                      <Accreditation />
                    </Route>
                    <Route path={"/folder/viewElectionResult"}>
                      <WinnersPage />
                    </Route>
                    <Route path={"/folder/castVotes"}>
                      <VotingPage />
                    </Route>
                    <Route path={"/folder/monitorElection"}>
                      <MonitorPage />
                    </Route>
                    <Route path={"/folder/setupElection"}>
                      <ElectionSetup />
                    </Route>
                    <Route path={"/folder/manage-election/:id"}>
                      <ManageElection />
                    </Route>
                    <Route path={"/folder/viewElectionResults/:id"}>
                      <ViewResultPage />
                    </Route>
                    <Route path={"/folder/setupstaff/:name"}>
                      <CreateStaff />
                    </Route>
                    <Route path={"/folder/setupfaqs/:name"}>
                      <AdminFaqs />
                    </Route>

                    <Route path={"/folder/opensupport/:name"}>
                      <SupportTicket />
                    </Route>
                    <Route path={"/folder/setupmember/:name"}>
                      <CreateMember />
                    </Route>
                    <Route path={"/folder/processorders/:name"}>
                      <StewardDashboard />
                    </Route>
                    <Route path={"/folder/myorderreport/:name"}>
                      <StewardOrderReports />
                    </Route>
                    <Route path={"/folder/view_my_requisition/:name"}>
                      <StewardRequestPage />
                    </Route>

                    <Route path={"/folder/view_my_requisition_branch/:name"}>
                      <StewardRequestPage_branch />
                    </Route>

                    <Route path={"/folder/reports/:report"}>
                      {/* <OrderReports /> */}
                      <StewardOrderReports />
                    </Route>

                    <Route path={"/folder/viewstewardstock/:report"}>
                      {/* <OrderReports /> */}
                      <ViewStewardStock />
                    </Route>

                    <Route path={"/folder/stewardzeroLogReport/:name"}>
                      <MyStewardStockTransferLogs />
                    </Route>

                    <Route path={"/folder/stewardtransferlogs/:name"}>
                      <StewardStockTransferLogs />
                    </Route>



                    <Route path={"/folder/vendor_invoices"}>
                      <InvoiceDashboard />
                    </Route>

                    <Route path={"/folder/invoice_payments_history"}>
                      <PaymentHistoryDashboard />
                    </Route>



                    <Route path={"/folder/stewardstocklist"}>
                      <StewardStocklist />
                    </Route>

                    <Route path={"/folder/self_order/:name"}>
                      <POSPage_StewardSelf />
                    </Route>
                    <Route path={"/folder/view_steward_requisition/:name"}>
                      <StewardPurchaseOrderRequestPage />
                    </Route>
                    <Route path={"/folder/raise-order/:name"}>
                      <SalesPOSPage />
                    </Route>

                    <Route path={"/folder/raise-order_bar/:name"}>
                      <PosPage_bar />
                    </Route>

                    <Route path={"/folder/raise-order_hotel_shop/:name"}>
                      <PosPage_hotel_shop />
                    </Route>

                    <Route path={"/folder/raise-receipt/:name"}>
                      <CustomerAccountPage />
                    </Route>

                    <Route path={"/folder/raise-receipt_bar/:name"}>
                      {/* <CustomerAccountPage_bar /> */}
                    </Route>

                    <Route path={"/folder/my_activity/:name"}>
                      <ActivityReporting />
                    </Route>

                    <Route path={"/folder/manage_staff_activity/:name"}>
                      <AdminTaskManagement />
                    </Route>

                    <Route path={"/folder/raise-receipt_giftcard_crypto/:name"}>
                      <CustomerAccountPage_giftcard_crypto />
                    </Route>

                    <Route path={"/folder/raise-receipt_giftcard_crypto"}>
                      <CustomerAccountPage_giftcard_crypto_fdesk />
                    </Route>

                    <Route
                      path={"/folder/pending_raise_receipt_giftcard_crypto/:name"}
                    >
                      <CustomerAccountPage_giftcard_crypto_pending />
                    </Route>

                    <Route
                      path={"/folder/xcrm_pending_raise_receipt_crm/:name"}
                    >
                      <CustomerAccountPage_pending />
                    </Route>

                    <Route
                      path={"/folder/manage_online_bookings/:name"}
                    >
                      <ManageOnlineBooking />
                    </Route>

                    <Route
                      path={"/folder/excadmin_xexchange_pending_raise_receipt_crmx/:name"}
                    >
                      <CustomerAccountPage_pending_admin_view />
                    </Route>

                    <Route
                      path={
                        "/folder/xexchange_pending_raise_receipt_giftcard_crypto_current/:name"
                      }
                    >
                      <CustomerAccountPage_giftcard_crypto_pending_om />
                    </Route>

                    <Route
                      path={
                        "/folder/pending_raise_receipt_checkin_checkout/:name"
                      }
                    >
                      <CustomerAccountPage_checkin_checkout />
                    </Route>

                    <Route
                      path={"/folder/pending_raise_receipt_reservations/:name"}
                    >
                      <CustomerAccountPage_reservations />
                    </Route>

                    {/* <Route
                    path={"/folder/pending_raise_receipt/:name"}
                  >
                    <CustomerAccountPage_reservations />
                  </Route> */}


                    <Route
                      path={
                        "/folder/pending_raise_receipt_giftcard_crypto_om/:name"
                      }
                    >
                      <CustomerAccountPage_giftcard_crypto_pending_om />
                    </Route>

                    <Route
                      path={
                        "/folder/process_payout_receipt_giftcard_crypto/:name"
                      }
                    >
                      <CustomerAccountPage_giftcard_crypto_all />
                    </Route>

                    <Route path={"/folder/process_payout_receipt_crypto/:name"}>
                      <CustomerAccountPage_crypto />
                    </Route>

                    <Route path={"/folder/accountPage_search_by_code/:name"}>
                      <CustomerAccountPage_search_by_code />
                    </Route>

                    <Route
                      path={
                        "/folder/exchange_accountPage_search_by_code_diff/:name"
                      }
                    >
                      <CustomerAccountPage_search_by_code />
                    </Route>

                    <Route path={"/folder/accountPage_search_by_code_1/:name"}>
                      <CustomerAccountPage_search_by_code_1 />
                    </Route>

                    <Route
                      path={
                        "/folder/process_payout_conf_receipt_giftcard_crypto/:name"
                      }
                    >
                      <CustomerAccountPage_conf_giftcard_crypto_all />
                    </Route>

                    <Route
                      path={"/folder/process_payout_conf_receipt_crypto/:name"}
                    >
                      <CustomerAccountPage_conf_crypto />
                    </Route>

                    <Route
                      path={
                        "/folder/_exchange_raise_receipt_giftcard_crypto_admin"
                      }
                    >
                      <CustomerAccountPage_giftcard_crypto />
                    </Route>
                    <Route path={"/folder/stock-indvidual-report/:name"}>
                      <StockSalesReportPage />
                    </Route>
                    <Route path={"/folder/customer-status-report/:name"}>
                      <CustomerStatusReportPage />
                    </Route>
                    <Route path={"/folder/customer_profit_report/:name"}>
                      <CustomerProfitReportPage />
                    </Route>

                    <Route path={"/folder/customer-indvidual-report2/:name"}>
                      <CustomerAccountPage_accounts_exchange />
                    </Route>

                    <Route path={"/folder/customer-indvidual-report/:name"}>
                      <CustomerAccountPage_account />
                    </Route>

                    {/* reports */}
                    <Route path={"/folder/cashier-reports/:name"}>
                      <SalesReportPage />
                    </Route>

                    <Route path={"/folder/cashier-reciept/:name"}>
                      <SalesRecieptPage />
                    </Route>

                    <Route path={"/folder/cashier-reciept_exchange/:name"}>
                      <SalesRecieptPage_Ex />
                    </Route>

                    <Route path={"/folder/manager-sales-report/:name"}>
                      <ManagerSalesReportPage />
                    </Route>
                    <Route path={"/folder/manager-sales-reciept/:name"}>
                      <ManagerSalesReportPage_R />
                    </Route>


                    <Route path={"/folder/receptionist_report/:name"}>
                      <ReceptionistSalesReport />
                    </Route>

                    <Route path={"/folder/xcrm_manager-sales-reciept_admin/:name"}>
                      <ManagerSalesReportPage_R_admin_view />
                    </Route>

                    <Route
                      path={"/folder/ex_manager-sales-reciept_exchange/:name"}
                    >
                      <ManagerSalesReportPage_R_Exchange />
                    </Route>
                    <Route
                      path={"/folder/manager-sales-reciept_exchange_usd/:name"}
                    >
                      <ManagerSalesReportPage_R_Exchange_usd />
                    </Route>

                    <Route
                      path={
                        "/folder/manager-sales-reciept_exchange_giftcard1/:name"
                      }
                    >
                      <ManagerSalesReportPage_R_Exchange_giftcard_history />
                    </Route>

                    <Route path={"/folder/manager-sales-reciept_giftcard/:name"}>
                      <ManagerSalesReportPage_R_Giftcard />
                    </Route>

                    <Route
                      path={"/folder/manager-sales-reciept_giftcard_audit/:name"}
                    >
                      <ManagerSalesReportPage_R_Giftcard_audit />
                    </Route>

                    {/* <Route path={"/folder/manager-sales-reciept_crypto/:name"}>
                    <ManagerSalesReportPage_R_Crypto />
                  </Route> */}

                    <Route path={"/folder/mark_attendance/:name"}>
                      <MarkAttendance />
                    </Route>

                    <Route path={"/folder/mark_perfomance/:name"}>
                      <MarkPerformance />
                    </Route>

                    <Route path={"/folder/stock-status/:name"}>
                      <StockStatus />
                    </Route>
                    <Route path={"/folder/customer-centre/:name"}>
                      <CustomerListPage />
                    </Route>

                    <Route path={"/folder/sundry_debtors/:name"}>
                      <SundryDebtorsPage />
                    </Route>
                    <Route path={"/folder/sundry_creditors/:name"}>
                      <SundryCreditorsPage />
                    </Route>

                    <Route path={"/folder/staff_performance_1/:name"}>
                      <StaffPerformancePage1 />
                    </Route>

                    <Route path={"/folder/product_performance_1/:name"}>
                      <ProductPerformancePage1 />
                    </Route>

                    <Route path={"/folder/processor_report/:name"}>
                      <ProcessorPerformancePage1 />
                    </Route>

                    <Route path={"/folder/customer_performance_1/:name"}>
                      <CustomerPerformancePage1 />
                    </Route>

                    <Route path={"/folder/sales-analysis/:name"}>
                      <SalesAnalysis />
                    </Route>
                    <Route path={"/folder/purchase-analysis/:name"}>
                      <PurchaseReport />
                    </Route>
                    <Route path={"/folder/outstanding-analysis/:name"}>
                      <OutstandingAnalysis />
                    </Route>
                    <Route path={"/folder/customer-account/:name"}>
                      <CustomersReport />
                    </Route>

                    {/* funding */}
                    <Route path={"/folder/fund-account/:name"}>
                      <FundCustomerWallet />
                    </Route>
                    <Route path={"/folder/view-fund-report/:name"}>
                      <FundCustomerReport />
                    </Route>

                    {/* req */}
                    <Route path={"/folder/makearequest_sales/:name"}>
                      <BranchRequisitionPage />
                    </Route>
                    {/* product  */}

                    <Route path={"/folder/Productsetup_sales/:name"}>
                      <ProductSetupPage />
                    </Route>

                         <Route path={"/folder/xcl_crm_xProductsetup_sales_l/:name"}>
                      <ProductSetupPage />
                    </Route>



                    <Route path={"/folder/Productsetup_sales_all_branch/:name"}>
                      <ProductSetupPage_all_branch />
                    </Route>
                    <Route path={"/folder/categorySetup_sales/:name"}>
                      <CategoryPage />
                    </Route>

                    
                    <Route path={"/folder/online_2categorySetup_2sales/:name"}>
                      <OnlineCategoryPage />
                    </Route>

                    <Route path={"/folder/gradeSetup_sales/:name"}>
                      <GradeSetupPage />
                    </Route>

                    {/* req */}
                    <Route path={"/folder/create-bom/:name"}>
                      <ManageBOMTable />
                    </Route>

                    <Route
                      path="/folder/bom-manage/:id"
                      component={BOMDetailPage}
                      exact
                    />

                    <Route
                      path="/folder/branchRequisition"
                      component={BranchRequestPage}
                      exact
                    />

                    {/* memeb */}

                    {/* hr route  */}
                    {/* <Route path={"/folder/create-bom/:name"}>
                    <PayrollSystem />
                  </Route> */}
                    <Route
                      path="/folder/payroll-setup/:name"
                      component={PayrollSystem}
                      exact
                    />
                    <Route
                      path="/folder/my-payslips/:name"
                      component={MyPayslips}
                      exact
                    />

                    <Route
                      path="/folder/allowances-deductions/:name"
                      component={EmployeeUploadPage}
                      exact
                    />

                    <Route
                      path="/folder/salary-scale/:name"
                      component={PayrollSettings}
                      exact
                    />
                    <Route
                      path="/folder/manage-whistle/:name"
                      component={ManagementPage}
                      exact
                    />
                    {/* Other routes */}
                    <Route
                      path="/folder/viewEnrolledCourse"
                      component={ViewEnrolledCourse}
                      exact
                    />

                    <Route path={"/folder/takecourses/"}>
                      <EnrollCourse />
                    </Route>

                    <Route path={"/folder/lmssetup/"}>
                      <Create />
                    </Route>

                    <Route path={"/folder/inappmessaging/"}>
                      <InAppMesssging />
                    </Route>

                    <Route
                      path="/folder/case-setup/:name"
                      component={CasePage}
                      exact
                    />

                    <Route
                      path="/folder/my-recommendations/:name"
                      component={Recommendation}
                      exact
                    />
                    <Route
                      path="/folder/view-recommendations"
                      component={UserRecommendation}
                      exact
                    />
                    <Route
                      path="/folder/requisition-details/:id"
                      component={RequisitionDetails}
                      exact
                    />
                    <Route
                      path="/folder/all-recommendations/:name"
                      component={RecommendationList}
                      exact
                    />
                    <Route
                      path="/folder/manager-requisitions/:name"
                      component={ManagerRequisitionsPage}
                      exact
                    />
                    <Route
                      path="/folder/my-requisition/:name"
                      component={CreateRequisitionPage}
                      exact
                    />
                    <Route
                      path="/folder/my-requisition/:name"
                      component={CreateRequisitionPage}
                      exact
                    />
                    <Route
                      path="/folder/view-disciplinary/:name"
                      component={EmployerDisciplinaryView}
                      exact
                    />
                    <Route
                      path="/folder/my-disciplinary/:name"
                      component={EmployeeDisciplinaryView}
                      exact
                    />
                    <Route
                      path="/folder/issue-disciplinary/:name"
                      component={IssueDisciplinaryQueryPage}
                      exact
                    />
                    <Route
                      path="/folder/disciplinary/issue"
                      component={IssueDisciplinaryQueryPage}
                      exact
                    />

                    <Route
                      path="/folder/disciplinary"
                      component={DisciplinaryCaseDetailPage}
                      exact
                    />
                    <Route
                      path="/folder/leave_detailpage"
                      component={LeaveDetailPage}
                      exact
                    />
                    <Route
                      path="/folder/manage-leaaves/:name"
                      component={EmployerLeaveView}
                      exact
                    />
                    <Route
                      path="/folder/apply_leavepage"
                      component={ApplyLeavePage}
                      exact
                    />

                    {/* jobs */}
                    <Route
                      path="/folder/manage-job/:name"
                      component={JobManagementPage}
                      exact
                    />
                    <Route
                      path="/folder/view-jobs/:name"
                      component={JobListPage}
                      exact
                    />
                    <Route path="/folder/jobs/:id" component={JobDetails} exact />
                    <Route
                      path="/folder/jobs/:jobID/quiz"
                      component={JobQuestionsPage}
                      exact
                    />
                    <Route
                      path="/folder/view-jobs-applicant/:name"
                      component={JobListPage}
                      exact
                    />
                    <Route
                      path="/folder/applicants/:id"
                      component={JobApplicantPage}
                      exact
                    />

                    <Route
                      path="/folder/apply/:id"
                      component={JobApplicationForm}
                      exact
                    />

                    {/* onboarding */}
                    <Route
                      path="/folder/setup-onboarding/:name"
                      component={HROnboardingView}
                      exact
                    />
                    <Route
                      path="/folder/view-onboarding/:name"
                      component={OnboardingPage}
                      exact
                    />
                    <Route
                      path="/folder/view-leaves/:name"
                      component={EmployeeLeaveView}
                      exact
                    />
                    <Route
                      path="/folder/whistle-blowing/:name"
                      component={WhistlePage}
                      exact
                    />
                    <Route
                      path="/folder/view-whistle-blowing/:name"
                      component={StaffPage}
                      exact
                    />
                    <Route
                      path="/folder/career-page"
                      component={CompanyCareerPage}
                      exact
                    />

                    {/* 
                  ----------------------
                  GkGS HR ROUTES
                  ----------------------
                  */}

                    <Route
                      exact
                      path="/folder/ats-projects-staff/:name"
                      component={ATSProjects_staff}
                    />

                    <Route
                      exact
                      path="/folder/ats-projects/:name"
                      component={ATSProjects}
                    />
                    <Route
                      exact
                      path="/folder/projects/:project_id"
                      component={ATSProjectDetail}
                    />
                    <Route
                      exact
                      path="/folder/projects/:project_id/:job_role"
                      component={ATSJobApplicants}
                    />
                    <Route
                      exact
                      path="/folder/manage-project/:name"
                      component={ProjectSetup}
                    />
                    <Route
                      exact
                      path="/folder/projectDetail"
                      component={ProjectDetail}
                    />

                    {/* course */}
                    <Route
                      exact
                      path="/folder/course-setup/:name"
                      component={CreateCourse}
                    />

                    {/* 
                   <Route
                    exact
                    path="/folder/module/:id"
                    component={ModulePage}
                  /> */}

                    <Route
                      exact
                      path="/folder/modulecourse/:id"
                      component={ModulePage}
                    />

                    <Route path="/folder/module/" component={ModulePage} />

                    {/* <Route path={"/folder/modulecourse/:id"}>
                    <ModulePage />
                  </Route>  */}
                    {/*  notification
                  <Route
                    exact
                    path="/folder/send-notification/:project_id"
                    component={ProjectApplicants}
                  />

                  <Route
                    exact
                    path="/folder/view-projects/:name"
                    component={AllProjects}
                  />

                  {/* dashboard */}
                    <Route
                      exact
                      path="/folder/assign-project/:name"
                      component={HRDashboard}
                    />
                    <Route
                      exact
                      path="/folder/job-setup/:name"
                      component={JobSetup}
                    />
                    {/* <Route
                    exact
                    path="/folder/job-setup/:name"
                    component={JobSetup}
                  /> */}
                    <Route
                      exact
                      path="/folder/projectDetail"
                      component={ProjectDetail}
                    />
                    <Route
                      exact
                      path="/folder/owner-dashboard/:name"
                      component={BusinessOwnerDashboard}
                    />
                    <Route
                      exact
                      path="/folder/projects"
                      component={BusinessOwnerProjectDetail}
                    />
                    <Route
                      exact
                      path="/folder/jobprojectdetail"
                      component={JobSetUpProjectDetail}
                    />
                    <Route
                      exact
                      path="/folder/view-applicants/:name"
                      component={ApplicantManagement}
                    />
                    <Route
                      exact
                      path="/folder/project-data/:name"
                      component={ProjectChart}
                    />

                    {/* SERVIES */}

                    <Route
                      exact
                      path="/folder/admin-service-request/:name"
                      component={AdminServiceRequests}
                    />
                    <Route
                      exact
                      path="/folder/staff-service-request/:name"
                      component={StaffRequestPage}
                    />
                    <Route
                      exact
                      path="/folder/client-service-request/:name"
                      component={BusinessRequestPage}
                    />

                    <Route
                      exact
                      path="/folder/add-staffs/:name"
                      // component={StaffManagementPage}

                      component={StaffManagementGeneral}
                    />

                    <Route
                      exact
                      path="/folder/add-staffs_business_crm/:name"
                      component={StaffManagementCRM}
                    />

                    <Route
                      exact
                      path="/folder/setup_student_data_cbt/:name"
                      component={StudentManagementDashboard}
                    />

                    <Route
                      exact
                      path="/folder/add-staffs_business_crm_all/:name"
                      component={StaffManagementCRM_all}
                    />

                    <Route
                      exact
                      path="/folder/in-app-messaging/:name"
                      component={MailPage}
                    />

                    {/* Edo Specialist Hospital Accounting  */}


                    {/* ///////////////// 
                  // Edo Specialist Hospital Accounting  Inventory 
                  // */}

                    <Route
                      exact
                      path="/folder/inventory-grn/:name"
                      component={GRNManager}
                    />
                    <Route
                      exact
                      path="/folder/inventory-stock-movements/:name"
                      component={InventoryManagement}
                    />
                    <Route
                      exact
                      path="/folder/inventory-valuations/:name"
                      component={InventoryReportingValuation}
                    />
                    <Route
                      exact
                      path="/folder/inventory-write-offs/:name"
                      component={WriteOffManager}
                    />
                    <Route
                      exact
                      path="/folder/inventory-reorders/:name"
                      component={ReorderLevels}
                    />
                    <Route
                      exact
                      path="/folder/inventory-stocks-alert/:name"
                      component={StocksAlert}
                    />

                    {/* ///////////////// 
                  // Edo Specialist Hospital Accounting  -Accontant 
                  // */}
                    {/* <Route
                    exact
                    path="/folder/chart-asset-register/:name"
                    component={AssetRegisterList}
                  /> */}

                    {/* <Route
  exact
  path="/folder/chart-asset-register/:name"
  component={AssetRegisterList}
/> */}

                    {/* <Route
  exact
  path="/folder/customer-setup-classification/:name"
  component={CustomerList}
/> */}

                    <Route
                      exact
                      path="/folder/chart-asset-register/:name"
                      component={AssetRegisterList}
                    />


                    <Route
                      exact
                      path="/folder/reverse-posting/:name"
                      component={PostingsByPostCode}
                    />


                    <Route
                      exact
                      path="/folder/housekeeping_bulk/:name"
                      component={Housekeeping_bulk}
                    />

                    <Route
                      exact
                      path="/folder/housekeeping/:name"
                      component={Housekeeping}
                    />

                    <Route
                      exact
                      path="/folder/assignment/:name"
                      component={AssignmentReport}
                    />



                    <Route
                      exact
                      path="/folder/roomstatusreport/:name"
                      component={RoomStatusReport}
                    />

                    <Route
                      exact
                      path="/folder/registerlost_found/:name"
                      component={RegisterLostAndFound}
                    />


                    {/* FOOD AND BEVERAGE SUPERVISOR DASHBOARD */}

                    <Route
                      exact
                      path="/folder/waiter_attendance_entry/:name"
                      component={WaiterAttendance}
                    />

                    <Route
                      exact
                      path="/folder/daily_waiter_assignments/:name"
                      component={WaiterAssignment}
                    />

                    <Route
                      exact
                      path="/folder/assignment_tracking/:name"
                      component={AssignmentHistory}
                    />

                    <Route
                      exact
                      path="/folder/attendance_history/:name"
                      component={AttendanceHistory}
                    />

                    <Route
                      exact
                      path="/folder/add_departmental_inventory/:name"
                      component={AddInventory}
                    />

                    <Route
                      exact
                      path="/folder/remove_departmental_inventory/:name"
                      component={RemoveInventory}
                    />


                    <Route
                      exact
                      path="/folder/departmental_inventory_tracking/:name"
                      component={InventoryHistory}
                    />

                    <Route
                      exact
                      path="/folder/daily_sales_entry/:name"
                      component={RecordSale}
                    />

                    <Route
                      exact
                      path="/folder/sales_summary_dashboard/:name"
                      component={SalesDashboardBFSupervisor}
                    />

                    <Route
                      exact
                      path="/folder/fb_raise_requisitions/:name"
                      component={CreateRequisitionFb}
                    />

                    <Route
                      exact
                      path="/folder/fb_stock_requisitions/:name"
                      component={RequisitionHistoryFb}
                    />

                    <Route
                      exact
                      path="/folder/fb_dispense_stock/:name"
                      component={DispenseStockFb}
                    />


                    <Route
                      exact
                      path="/folder/fb_track_stock/:name"
                      component={DispenseHistoryFb}
                    />



                    {/* <Route
                    exact
                    path="/folder/viewlost_found/:name"
                    component={ViewAndLostFound}
                  /> */}



                    <Route
                      exact
                      path="/folder/chart-reversal-posting/:name"
                      component={ReversalEntries}
                    />

                    <Route
                      exact
                      path="/folder/chart-package-posting/:name"
                      component={PackagePosting}
                    />

                    <Route
                      exact
                      path="/folder/my_posting_report/:name"
                      component={MyReport}
                    />

                    <Route
                      exact
                      path="/folder/all_posting_report/:name"
                      component={AllReport}
                    />



                    <Route
                      exact
                      path="/folder/invoice_status_tracking/:name"
                      component={InvoiceDashboard}
                    />

                    <Route
                      exact
                      path="/folder/vendors-delivery-notice/:name"
                      component={DeliveryNoticeDashboard}
                    />

                    <Route
                      exact
                      path="/folder/vendors-discrepancy-report/:name"
                      component={DiscrepancyDashboard}
                    />

                    <Route
                      exact
                      path="/folder/vendors-payments-history/:name"
                      component={PaymentHistoryDashboard}
                    />

                    <Route
                      exact
                      path="/folder/customer-setup-classification/:name"
                      component={CustomerList}
                    />

                    <Route
                      exact
                      path="/folder/customer-aging-uncompleted-invoices/:name"
                      component={CustomerAging}
                    />

                    <Route
                      exact
                      path="/folder/statements-ledger-report/:name"
                      component={CustomerStatement}
                    />

                    <Route
                      exact
                      path="/folder/invoice-allocation/:name"
                      component={InvoiceForm}
                    />


                    <Route
                      exact
                      path="/folder/payment-receipts-history/:name"
                      component={CustomerReceipts}
                    />


                    {/* 
chinedu

*/}

                    {/* <Route
  exact
  path="/folder/customer-sales-invoices/:name"
  component={CustomerInvoices}
/>  */}

                    <Route
                      exact
                      path="/folder/credit-notes-refund/:name"
                      component={RefundRequestForm}
                    />


                    <Route
                      exact
                      path="/folder/receipt-entry/:name"
                      component={CustomerReceipts}
                    />

                    <Route
                      exact
                      path="/folder/customer-setup-classification/:name"
                      component={CustomerList}
                    />

                    <Route
                      exact
                      path="/folder/customer-aging-uncompleted-invoices/:name"
                      component={CustomerAging}
                    />

                    <Route
                      exact
                      path="/folder/customer-completed-invoice/:name"
                      component={InvoiceDetail}
                    />





                    {/* List Page */}
                    {/* <Route exact path="/folder/customer-setup-classification/:name" component={CustomerList} /> */}

                    {/* Create New - MUST be before :id routes */}
                    <Route exact path="/folder/customers_new" component={CustomerForm} />

                    {/* Edit - specific with /edit suffix */}
                    <Route exact path="/folder/customers_edit/:id" component={CustomerForm} />




                    {/* PARAMETERIZED ROUTES LAST */}

                    {/* Detail View with optional tab */}
                    <Route path="/customers/:id" component={CustomerDetail} />

                    {/* partial-advance-payments */}





                    <Route
                      exact
                      path="/folder/vendors-approved-orders/:name"
                      component={PurchaseOrderDashboard}
                    />



                    {/* <Route
  exact
  path="/folder/chart-asset-posting/:name"
  component={ManualAssetPosting}
/>            */}




                    {coreAccountingPages.map((page) => {
                      return (
                        <Route key={page.path} path={page.path} exact={true}>
                          <page.component />
                        </Route>
                      );
                    })}

                    <Route
                      exact
                      path="/folder/chart-manual-posting/:name"
                      component={ManualLedgerPosting}
                    />



                    {/**
                   * Vendor Mannagement
                   * */}




                    <Route
                      exact
                      path="/folder/vendors/:name"
                      component={VendorList}
                    />
                    <Route
                      exact
                      path="/folder/vendor/:vendor_id"
                      component={VendorDetail}
                    />
                    <Route
                      exact
                      path="/folder/chart-of-accounts/:name"
                      component={ChartOfAccountsPage}
                    />


                    <Route
                      exact
                      path="/folder/chart-of-accounts-list"
                      component={ChartOfAccountsList}
                    />
                    <Route
                      exact
                      path="/folder/financial_report/:name"
                      component={FinancialReportTree}
                    />
                    <Route
                      exact
                      path="/folder/balance_sheet-pl"
                      component={FinancialReportTree}
                    />




                    <Route
                      exact
                      path="/folder/ledger_report_b/:name"
                      component={SimpleLedgerReport}
                    />
                    <Route
                      exact
                      path="/folder/balance-sheet/:name"
                      component={BalanceSheetReport}
                    />
                    <Route
                      exact
                      path="/folder/profit-loss-report/:name"
                      component={ProfitAndLoss}
                    />

                    {/**
                   * Procedures
                   * */}

                    <Route
                      exact
                      path="/folder/manage-procedures/:name"
                      component={ProcedureList}
                    />
                    <Route
                      exact
                      path="/folder/manage-taxes/:vendor_id"
                      component={TaxList}
                    />

                    {/**
                   * Requsisition Management
                   * */}
                    <Route
                      exact
                      path="/folder/create-requisition/:name"
                      component={WarehouseRequisitionSystem}
                    />
                    {/* <Route
                    exact
                    path="/folder/ward-create-requisitions/:name"
                    component={WarehouseRequisitionSystem}
                  /> */}
                    {/* <Route
                    exact
                    path="/folder/ward-view-requisitions/:name"
                    component={WarehouseRequisitionPage}
                  /> */}

                    <Route
                      exact
                      path="/folder/view-purchase-requisitions/:name"
                      component={PurchaseOfficerPage}
                    />

                    <Route
                      exact
                      path="/folder/setup_cbt_courses/:name"
                      component={CbtCourses}
                    />

                    <Route
                      exact
                      path="/folder/setup_cbt_exams/:name"
                      component={CbtExams}
                    />

                    <Route
                      exact
                      path="/folder/setup_cbt_questions/:name"
                      component={CBTQuestionsDashboard}
                    />



                    <Route
                      exact
                      path="/folder/suspense_invoice/:name"
                      component={SuspenseInvoiceDashboard}
                    />


                    <Route
                      exact
                      path="/folder/my_available_exams/:name"
                      component={StudentExamInterface}
                    />

                    <Route
                      exact
                      path="/folder/view_cbt_report/:name"
                      component={CBTExamReport}
                    />


                    <Route
                      exact
                      path="/folder/audit_view_requisition/:name"
                      component={AuditOfficerPage}
                    />
                    {/**
                   * Item Request Management
                   * */}

                    <Route
                      exact
                      path="/folder/create-item-request/:name"
                      component={ItemRequestPage}
                    />


                    {/* <Route
                    exact
                    path="/folder/create-item-request/:name"
                    component={ItemRequestPage}
                  /> */}


                    <Route
                      exact
                      path="/folder/view-item-request/:name"
                      component={ItemTransferPage}
                    />


                    <Route
                      exact
                      path="/folder/cmd-pending-requisitions/:name"
                      component={CMDApprovalPage}
                    />



                    {/* {customerRoutes.map((route, index) => (
                            <Route
                                key={index}
                                path={`${route.path}`}
                                exact={route.exact}
                                component={route.component}
                            />
                        ))} */}




                    {/**
                        * vendor self service 
                        */}

                    <Route

                      path={`/folder/vendor/register/:name`}
                      exact
                      component={RegisterPage}
                    />
                    <Route

                      path={`/folder/vendor/purchaseDashnoard`}
                      exact
                      component={PurchaseOrderDashboard}
                    />
                  </>
                </IonRouterOutlet>
              </IonSplitPane>




            ) : (
              <>

                <Redirect exact path="/" to="/login" />
                <Route path={"/login"}>
                  {" "}
                  <LoginPage />
                </Route>

                <Route path={"/staff-register"}>
                  <StaffRegistration />
                </Route>

                <Route path={"/forgot_password"}>
                  <ForgotPassword />
                </Route>
                <Route path={"/Bookprintcalc"}>
                  <Bookprintcalc />
                </Route>

              </>

            )}





            {/* <Redirect exact path="/" to="/login" /> */}
          </IonReactRouter>
          {(Number(getUser()?.loginData?.roleID) === 14 ||
            Number(getUser()?.loginData?.roleID) === 13) && (
              <NotificationListener userId={userId} />
            )}

          <ToastContainer />

        </AuthContext.Provider>
      </LocalizationProvider>
    </IonApp >
  );
};

export default App;
